import { useRecoilValue } from 'recoil';
import dataManagementEntityAtom from 'ProjectManager/DataManagement/Common/recoil/dataManagementEntity/dataManagementEntityAtom';
import dataManagementEntities from 'ProjectManager/DataManagement/Common/constants/dataManagementEntities';
import useProjectGiveSingleChoiceAnswerFunction from 'ProjectManager/DataManagement/Questionnaire/components/Question/Answers/hooks/giveSingleChoiceAnswer/useProjectGiveSingleChoiceAnswerFunction';
import useTemplateGiveSingleChoiceAnswerFunction from 'ProjectManager/DataManagement/Questionnaire/components/Question/Answers/hooks/giveSingleChoiceAnswer/useTemplateGiveSingleChoiceAnswerFunction';

const useGiveSingleChoiceAnswerFunction = (questionId, isCustomQuestion) => {
    const dataManagementEntity = useRecoilValue(dataManagementEntityAtom);

    const dataFromProject = useProjectGiveSingleChoiceAnswerFunction(
        questionId,
        isCustomQuestion,
    );

    const dataFromTemplate = useTemplateGiveSingleChoiceAnswerFunction(
        questionId,
        isCustomQuestion,
    );

    if (dataManagementEntity === dataManagementEntities.PROJECT) {
        return dataFromProject;
    }

    if (dataManagementEntity === dataManagementEntities.TEMPLATE) {
        return dataFromTemplate;
    }

    return {};
};

export default useGiveSingleChoiceAnswerFunction;
